/* Seções "Pet ·" — interações (antes/depois, checklist, barra fixa, produto personalizado) */
(function () {
  'use strict';
  if (window.__ppLanding) return;
  window.__ppLanding = true;

  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2).split('.');
    var int = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var str = int + ',' + v[1];
    return (fmt || 'R$ {{amount}}').replace(/\{\{\s*amount[^}]*\}\}/, str);
  }

  /* ---------- Antes / depois ---------- */
  function initBA(root) {
    root.querySelectorAll('.pp-ba:not([data-ready])').forEach(function (ba) {
      ba.setAttribute('data-ready', '1');
      var r = ba.querySelector('.pp-ba__range');
      if (!r) return;
      var set = function () { ba.style.setProperty('--pos', r.value + '%'); };
      r.addEventListener('input', set);
      set();
      // pequena "dica" de movimento quando aparece na tela
      if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (!e.isIntersecting) return;
            io.disconnect();
            var start = null, from = +r.value;
            function step(t) {
              if (!start) start = t;
              var p = Math.min((t - start) / 1400, 1);
              r.value = from + Math.sin(p * Math.PI * 2) * 14;
              set();
              if (p < 1) requestAnimationFrame(step); else { r.value = from; set(); }
            }
            requestAnimationFrame(step);
          });
        }, { threshold: 0.6 });
        io.observe(ba);
      }
    });
  }

  /* ---------- Checklist de fotos ---------- */
  function initChecklist(root) {
    root.querySelectorAll('.pp-check:not([data-ready])').forEach(function (box) {
      box.setAttribute('data-ready', '1');
      var inputs = box.querySelectorAll('input[type=checkbox]');
      var bar = box.querySelector('.pp-check__meter span');
      var msg = box.querySelector('.pp-check__msg');
      var msgs = { none: box.dataset.msgNone, some: box.dataset.msgSome, all: box.dataset.msgAll };
      function upd() {
        var n = 0; inputs.forEach(function (i) { if (i.checked) n++; });
        var pct = inputs.length ? n / inputs.length * 100 : 0;
        if (bar) bar.style.width = pct + '%';
        var done = n === inputs.length && n > 0;
        box.classList.toggle('is-done', done);
        if (msg) msg.textContent = done ? msgs.all : (n ? (msgs.some || '').replace('[x]', n).replace('[y]', inputs.length) : msgs.none);
      }
      inputs.forEach(function (i) { i.addEventListener('change', upd); });
      upd();
    });
  }

  /* ---------- Barra fixa ---------- */
  function initSticky(root) {
    root.querySelectorAll('.pp-sticky:not([data-ready])').forEach(function (bar) {
      bar.setAttribute('data-ready', '1');
      if (bar.parentElement !== document.body) document.body.appendChild(bar);
      var after = bar.dataset.after || 500;
      var hideNear = document.querySelectorAll('[data-pp-hide-sticky]');
      var visible = new Set();
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) visible.add(e.target); else visible.delete(e.target); });
          upd();
        });
        hideNear.forEach(function (el) { io.observe(el); });
      }
      function upd() { bar.classList.toggle('is-on', window.scrollY > after && visible.size === 0); }
      window.addEventListener('scroll', upd, { passive: true });
      upd();
    });
  }

  /* ---------- Produto personalizado ---------- */
  function initProduct(root) {
    root.querySelectorAll('[data-pp-product]:not([data-ready])').forEach(function (sec) {
      sec.setAttribute('data-ready', '1');
      var form = sec.querySelector('form.pp-form');
      var dataEl = sec.querySelector('[data-pp-product-json]');
      if (!form || !dataEl) return;
      var product = JSON.parse(dataEl.textContent);
      var cfg = form.dataset;
      var fmt = cfg.moneyFormat;
      var pix = parseFloat(cfg.pixDiscount || 0);
      var inst = parseInt(cfg.installments || 1, 10);
      var minP = parseInt(cfg.minPhotos || 1, 10);
      var maxP = parseInt(cfg.maxPhotos || 1, 10);
      var minRes = parseInt(cfg.minRes || 800, 10);
      var files = []; // {file, url, w, h, low}

      /* galeria */
      var main = sec.querySelector('.pp-prod__main img');
      sec.querySelectorAll('.pp-prod__thumb').forEach(function (b) {
        b.addEventListener('click', function () {
          sec.querySelectorAll('.pp-prod__thumb').forEach(function (x) { x.classList.remove('is-active'); });
          b.classList.add('is-active');
          if (main) { main.src = b.dataset.src; main.srcset = b.dataset.srcset || ''; }
        });
      });

      /* variantes */
      var idInput = form.querySelector('input[name="id"]');
      var priceNow = sec.querySelectorAll('[data-pp-price]');
      var priceOld = sec.querySelectorAll('[data-pp-compare]');
      var pixEl = sec.querySelectorAll('[data-pp-pix]');
      var instEl = sec.querySelectorAll('[data-pp-inst]');
      function current() {
        var sel = [];
        form.querySelectorAll('[data-pp-option]').forEach(function (g) {
          var c = g.querySelector('input:checked'); sel.push(c ? c.value : null);
        });
        if (!sel.length) return product.variants.find(function (v) { return String(v.id) === idInput.value; }) || product.variants[0];
        return product.variants.find(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); });
      }
      function updVariant() {
        var v = current();
        var btn = form.querySelector('[data-pp-submit]');
        if (!v) { btn.disabled = true; return; }
        idInput.value = v.id;
        btn.disabled = !v.available;
        btn.querySelector('.pp-btn__label').textContent = v.available ? btn.dataset.label : btn.dataset.soldout;
        var whole = Math.floor(v.price / 100), cents = String(v.price % 100).padStart(2, '0');
        priceNow.forEach(function (el) {
          el.innerHTML = '<span class="pp-price__cur">R$</span>' + String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + '<sup>,' + cents + '</sup>';
        });
        priceOld.forEach(function (el) {
          if (v.compare_at_price && v.compare_at_price > v.price) { el.textContent = money(v.compare_at_price, fmt); el.hidden = false; }
          else el.hidden = true;
        });
        pixEl.forEach(function (el) { el.textContent = money(Math.round(v.price * (1 - pix / 100)), fmt); });
        instEl.forEach(function (el) { el.textContent = inst + 'x de ' + money(Math.ceil(v.price / inst), fmt); });
        var stickyP = document.querySelectorAll('[data-pp-sticky-price="' + sec.dataset.section + '"]');
        stickyP.forEach(function (el) { el.textContent = money(v.price, fmt); });
        document.querySelectorAll('[data-pp-for="' + sec.dataset.section + '"]').forEach(function (el) {
          var k = el.dataset.ppBind;
          if (k === 'pix') el.textContent = money(Math.round(v.price * (1 - pix / 100)), fmt);
          else if (k === 'full') el.textContent = money(v.price, fmt);
          else if (k === 'inst') el.textContent = inst + 'x de ' + money(Math.ceil(v.price / inst), fmt);
        });
      }
      form.querySelectorAll('[data-pp-option] input').forEach(function (i) { i.addEventListener('change', updVariant); });
      updVariant();

      /* upload */
      var up = form.querySelector('.pp-up');
      var upInput = up ? up.querySelector('input[type=file]') : null;
      var grid = form.querySelector('.pp-up__grid');
      var holder = form.querySelector('[data-pp-files]');
      var chkCount = form.querySelector('[data-chk="count"]');
      var chkRes = form.querySelector('[data-chk="res"]');
      var chkName = form.querySelector('[data-chk="name"]');
      var nameInput = form.querySelector('[data-pp-name]');
      var err = form.querySelector('.pp-form__err');
      var counter = form.querySelector('[data-pp-count]');

      function loadImg(file) {
        return new Promise(function (res) {
          var url = URL.createObjectURL(file);
          var img = new Image();
          img.onload = function () { res({ url: url, img: img, w: img.naturalWidth, h: img.naturalHeight }); };
          img.onerror = function () { res({ url: null, img: null, w: 0, h: 0 }); };
          img.src = url;
        });
      }
      function shrink(info, file) {
        // reduz fotos grandes para no máx. 2400px (envio mais rápido e dentro do limite da Shopify)
        return new Promise(function (res) {
          var max = 2400;
          if (!info.img || (Math.max(info.w, info.h) <= max && file.size < 6e6)) return res(file);
          var s = max / Math.max(info.w, info.h);
          var c = document.createElement('canvas');
          c.width = Math.round(info.w * s); c.height = Math.round(info.h * s);
          c.getContext('2d').drawImage(info.img, 0, 0, c.width, c.height);
          c.toBlob(function (b) {
            if (!b) return res(file);
            res(new File([b], file.name.replace(/\.[^.]+$/, '') + '.jpg', { type: 'image/jpeg' }));
          }, 'image/jpeg', 0.9);
        });
      }
      async function addFiles(list) {
        for (var i = 0; i < list.length; i++) {
          if (files.length >= maxP) break;
          var f = list[i];
          if (!/^image\//.test(f.type) && !/\.(heic|heif)$/i.test(f.name)) continue;
          var info = await loadImg(f);
          var out = await shrink(info, f);
          files.push({ file: out, url: info.url, w: info.w, h: info.h, low: info.w > 0 && Math.min(info.w, info.h) < minRes });
        }
        render();
      }
      function render() {
        if (grid) {
          grid.innerHTML = '';
          files.forEach(function (o, idx) {
            var d = document.createElement('div');
            d.className = 'pp-up__th';
            d.innerHTML = (o.url ? '<img alt="" src="' + o.url + '">' : '<div class="pp-ph"></div>') +
              '<button type="button" aria-label="Remover foto">×</button>' +
              (o.low ? '<span class="pp-up__warn">Baixa resolução</span>' : '');
            d.querySelector('button').addEventListener('click', function () { files.splice(idx, 1); render(); });
            grid.appendChild(d);
          });
        }
        if (counter) counter.textContent = files.length + '/' + maxP;
        if (up) up.style.display = files.length >= maxP ? 'none' : '';
        // monta um input de arquivo por foto (enviado como propriedade do pedido)
        if (holder) {
          holder.innerHTML = '';
          var dtOK = typeof DataTransfer !== 'undefined';
          files.forEach(function (o, idx) {
            var inp = document.createElement('input');
            inp.type = 'file'; inp.hidden = true;
            inp.name = 'properties[' + (cfg.photoLabel || 'Foto') + ' ' + (idx + 1) + ']';
            if (dtOK) { try { var dt = new DataTransfer(); dt.items.add(o.file); inp.files = dt.files; } catch (e) {} }
            holder.appendChild(inp);
          });
        }
        checks();
      }
      function checks() {
        var okCount = files.length >= minP;
        var okRes = files.length > 0 && files.every(function (o) { return !o.low; });
        var okName = !nameInput || !nameInput.required || nameInput.value.trim().length > 0;
        if (chkCount) chkCount.classList.toggle('is-ok', okCount);
        if (chkRes) chkRes.classList.toggle('is-ok', okRes);
        if (chkName) chkName.classList.toggle('is-ok', okName);
        return { okCount: okCount, okName: okName };
      }
      if (upInput) {
        upInput.addEventListener('change', function () { addFiles(Array.from(upInput.files)); upInput.value = ''; });
        ['dragenter', 'dragover'].forEach(function (ev) { up.addEventListener(ev, function (e) { e.preventDefault(); up.classList.add('is-drag'); }); });
        ['dragleave', 'drop'].forEach(function (ev) { up.addEventListener(ev, function () { up.classList.remove('is-drag'); }); });
        up.addEventListener('drop', function (e) { e.preventDefault(); if (e.dataTransfer) addFiles(Array.from(e.dataTransfer.files)); });
      }
      if (nameInput) nameInput.addEventListener('input', checks);
      render();

      form.addEventListener('submit', function (e) {
        var c = checks();
        var msg = '';
        if (upInput && !c.okCount) msg = minP > 1 ? 'Envie pelo menos ' + minP + ' fotos para continuar.' : 'Envie a foto do seu pet para continuar.';
        else if (!c.okName) msg = 'Preencha o nome do pet.';
        if (msg) {
          e.preventDefault();
          err.textContent = msg; err.classList.add('is-on');
          (upInput && !c.okCount ? (up.style.display === 'none' ? grid : up) : nameInput).scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        err.classList.remove('is-on');
        var btn = form.querySelector('[data-pp-submit]');
        btn.classList.add('is-loading');
        btn.querySelector('.pp-btn__label').textContent = btn.dataset.loading;
        // envio nativo (multipart) — é o caminho suportado pela Shopify para anexar arquivos ao pedido
      });

    });
  }

  function init(root) {
    root = root || document;
    initBA(root); initChecklist(root); initProduct(root); initSticky(root);
  }
  // botões "rolar até o formulário"
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-pp-goto-form],[data-pp-goto]');
    if (!a) return;
    var ids = [a.dataset.ppGoto, 'pp-personalizar', 'pp-oferta'];
    var target = null;
    for (var i = 0; i < ids.length && !target; i++) if (ids[i]) target = document.getElementById(ids[i]);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
